import { IAccount } from '@site-mate/sitemate-global-shared/lib';
import { create } from 'zustand';

interface SMSAccountStore {
  smsAccount: IAccount | null;
  setSMSAccount: (smsAccount: IAccount | null) => void;
}

export const useSMSAccountStore = create<SMSAccountStore>((set) => ({
  smsAccount: null,
  setSMSAccount: (smsAccount: IAccount | null) => set({ smsAccount }),
}));
